import React, { FC, useState, useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styles from './create_new_folder_button.module.scss';
import { MaterialIcon } from '../../../../components/material-icon/MaterialIcon';
import { getErrorMessage } from '../../../../utils/errorMessage';
import { FoldersDropdownContext } from '../../FoldersDropdownContext';

type Props = {
  showDropdownCreate: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onFolderCreate: ({
    title,
    source,
  }: {
    title: string;
    source: string;
  }) => void;
};

export const CreateNewFolderButton: FC<Props> = ({
  showDropdownCreate,
  onFolderCreate,
}) => {
  const { searchValue, saveErrorMessage } = useContext(FoldersDropdownContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const intl = useIntl();

  const createFolder = async () => {
    setIsSubmitting(true);
    try {
      if (searchValue) {
        await onFolderCreate({ title: searchValue, source: 'dropdown-search' });
      }
    } catch (error) {
      if (error.response) {
        saveErrorMessage(getErrorMessage(error.response, intl.formatMessage));
      }
      setIsSubmitting(false);
    }
  };

  return !searchValue ? (
    <button
      type="button"
      className={styles.buttonChange}
      onClick={showDropdownCreate}
    >
      <MaterialIcon name="add_circle" className={styles.icon} />
      <FormattedMessage id="folders/create/CreateNewFolderButton.tsx/1" />
    </button>
  ) : (
    <button
      type="button"
      className={styles.buttonSubmit}
      onClick={createFolder}
      disabled={isSubmitting}
    >
      <MaterialIcon name="add_circle" className={styles.icon} />
      <FormattedMessage id="folders/create/CreateNewFolderButton.tsx/2" />
      <span className={styles.value}>{searchValue}</span>
    </button>
  );
};
